module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAA+0lEQVQ4je3TMUoDYRCG4XfG3RBrCZhGvISggr2QWNkqksIDWFgoFkFIUmzpASxSJV1yAkFEFztPEEGMYCBNiiXs7qQSEyTws9nSr5wZHr5mBOC6fVA2kgZQBUq45RusH8fxTVB7/ZLL+51Nz/NDYMsRWIwwEE121VvzbzMjAMY2qdYVoZIZ+bFMqgpsrAoBJc0BAeAfcoPSHBxTgUEO0IcC3VUVMTo6tUkAPGZnLJwyaQnARXdvvRjJOUIAFOauIuBzSY+hQK8Q+3f12kMk86ur9v6I35cZI+lR6+TlyaWXt2Q+lDQ5bJ6Fby7IX8h4Riirctw4Dd9dEYAZSoFCmK6sI3IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/menu/icn_chat.png
// module id = a+SB
// module chunks = 0